import { Skeleton } from "@devhop/ui";

export function EventDetailPageSkeleton() {
  return (
    <div
      className="space-y-6"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="ກຳລັງໂຫຼດງານສະແດງ"
    >
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0 flex-1 space-y-3">
          <div className="flex flex-wrap items-center gap-2">
            <Skeleton className="h-9 w-64 max-w-full" />
            <Skeleton className="h-6 w-24 rounded-full" />
            <Skeleton className="h-6 w-28 rounded-full" />
          </div>
          <Skeleton className="h-4 w-full max-w-xl" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-28" />
        </div>
      </div>

      <div className="flex flex-wrap gap-2 border-b pb-3">
        {["step-a", "step-b", "step-c", "step-d"].map((id) => (
          <Skeleton key={id} className="h-9 w-28 rounded-lg" />
        ))}
      </div>

      <div className="grid grid-cols-1 gap-0 divide-y rounded-xl border md:grid-cols-3 md:divide-x md:divide-y-0">
        {["overview-a", "overview-b", "overview-c"].map((id) => (
          <div key={id} className="space-y-3 p-5">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-7 w-40" />
            <Skeleton className="h-4 w-32" />
          </div>
        ))}
      </div>

      <div className="rounded-xl border">
        <div className="border-b px-5 py-4">
          <Skeleton className="h-5 w-40" />
        </div>
        <div className="space-y-4 p-5">
          {["team-a", "team-b", "team-c"].map((id) => (
            <div key={id} className="flex items-center gap-3">
              <Skeleton className="size-9 rounded-full" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-36" />
                <Skeleton className="h-3 w-48" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-xl border">
        <div className="border-b px-5 py-4">
          <Skeleton className="h-5 w-48" />
        </div>
        <div className="grid lg:grid-cols-[280px_1fr] lg:divide-x">
          <div className="space-y-2 border-b p-4 lg:border-b-0">
            {["doc-a", "doc-b"].map((id) => (
              <Skeleton key={id} className="h-20 w-full rounded-lg" />
            ))}
          </div>
          <div className="space-y-4 p-5">
            <Skeleton className="h-16 w-full rounded-lg" />
            <div className="grid gap-3 md:grid-cols-3">
              {["sum-a", "sum-b", "sum-c"].map((id) => (
                <Skeleton key={id} className="h-20 rounded-lg" />
              ))}
            </div>
            <Skeleton className="h-40 w-full rounded-lg" />
          </div>
        </div>
      </div>

      <div className="rounded-xl border p-5">
        <Skeleton className="mb-4 h-5 w-44" />
        <Skeleton className="h-24 w-full rounded-lg" />
      </div>
    </div>
  );
}
